import { CatalogCard } from './CatalogCard';
import type { CatalogItem } from '@gorampe/catalog-adapter';

interface Props {
  items: CatalogItem[];
  onSelect: (item: CatalogItem) => void;
}

export function CatalogGrid({ items, onSelect }: Props) {
  if (items.length === 0) {
    return <div className="py-12 text-center text-sm text-slate-500">Aucune pièce trouvée</div>;
  }
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
      {items.map((item) => (
        <CatalogCard key={item.sku as unknown as string} item={item} onClick={onSelect} />
      ))}
    </div>
  );
}
